import { createAsyncThunk } from '@reduxjs/toolkit';
import { WidgetFedopsLogger } from '../../components/Hoc/Fedops/FedopsProvider';
import { getGooglePayBaseOptions } from '../../utils/serverAPI/googlePay';
import { selectAuthParams, selectTopProps, selectAppDefId, selectAppInstanceId } from '../../selectors';
import { GooglePayStore, StoreState } from '../../types/StoreState';
import { InteractionName } from '../../types/InteractionName';
import { BiLogger } from '../../components/Hoc/BiLogger/BiLoggerProvider';

export interface GetGooglePayOptionsParams {
  fedopsLogger: WidgetFedopsLogger;
  biLogger: BiLogger;
}

export const getGooglePayOptions = createAsyncThunk<
  GooglePayStore['options']['data'],
  GetGooglePayOptionsParams,
  {
    state: StoreState;
  }
>('GET_GOOGLE_PAY_OPTIONS', async ({ fedopsLogger }, thunkAPI) => {
  const store = thunkAPI.getState();
  try {
    fedopsLogger.interactionStarted(InteractionName.GooglePayLoadOptions);
    const { value } = await getGooglePayBaseOptions({
      auth: selectAuthParams(store),
      domain: selectTopProps(store).domain,
      appDefId: selectAppDefId(store),
      appInstanceId: selectAppInstanceId(store),
    });
    const specification = value.tokenizationSpecification;
    const merchantInfo = value.merchantInfo;
    const data: GooglePayStore['options']['data'] = {
      merchantInfo: {
        merchantId: merchantInfo.id,
        merchantName: merchantInfo.name,
        authJwt: merchantInfo.authJwt,
        domain: merchantInfo.domain,
      },
      isSandbox: merchantInfo.isSandbox,
    };

    if (specification.gateway) {
      data.tokenizationSpecification = {
        type: 'PAYMENT_GATEWAY',
        parameters: {
          gateway: specification.gateway.gatewayId,
          gatewayMerchantId: specification.gateway.merchantId,
        },
      };
    }
    fedopsLogger.interactionEnded(InteractionName.GooglePayLoadOptions);
    return data;
  } catch (e) {
    // TODO: Add sentry ot remove catch
    throw e;
  }
});
